<template>
  <div id="app">
    <router-view />
    <van-tabbar route v-if="newVal!=='Login'&& newVal!=='BindOpenId' && newVal!=='payResult'" active-color="#00b998">
      <van-tabbar-item replace to="/tcmr/home" icon="home-o">首页</van-tabbar-item>
      <van-tabbar-item replace to="/tcmr/module" icon="apps-o">分类</van-tabbar-item>
      <van-tabbar-item replace to="/tcmr/post" icon="search">咨讯</van-tabbar-item>
      <van-tabbar-item replace to="/tcmr/user" icon="contact">个人中心</van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import Vue from "vue";
import { Tabbar, TabbarItem } from "vant";
console.log(Tabbar);
Vue.use(Tabbar);
Vue.use(TabbarItem);
export default {
  data() {
    return {
      newVal: ""
    };
  },
  watch: {
    "$route.name": function(newVal) {
      console.log(newVal);
      this.newVal = newVal;
    }
  }
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-bottom: 80px;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
